"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _ErrorApi = require("./../../../utils/ErrorApi");

var _ErrorApi2 = _interopRequireDefault(_ErrorApi);

var _Fetch = require("./../../../utils/Fetch");

var _Fetch2 = _interopRequireDefault(_Fetch);

var _ParamsFetch = require("./../../../utils/ParamsFetch");

var _ParamsFetch2 = _interopRequireDefault(_ParamsFetch);

var _JsonFetch = require("./../../../utils/JsonFetch");

var _JsonFetch2 = _interopRequireDefault(_JsonFetch);

var _generateUrl = require("./../../../utils/generateUrl");

var _generateUrl2 = _interopRequireDefault(_generateUrl);

var _UpdateMethods = require("./UpdateMethods");

var UpdateMethods = _interopRequireWildcard(_UpdateMethods);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Rychle prihlaseni v Marbesu pomoci univerzalniho hesla Generated from cz.marbes.react.MarbesAuthController.
 */
// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-01-07T22:11:17Z                      #

// ##############################################################

var MarbesAuthApi = function () {
  function MarbesAuthApi() {
    (0, _classCallCheck3.default)(this, MarbesAuthApi);
  }

  (0, _createClass3.default)(MarbesAuthApi, null, [{
    key: "check",

    /**
     * 
     *
     * @return 
     */
    value: function check() {
      var uri = serverContextPath + "/api/auth/check";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param credentials 
     * @return 
     */

  }, {
    key: "login",
    value: function login(credentials) {
      var uri = serverContextPath + "/api/auth/login";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, credentials, headers));
    }

    /**
     * 
     *
     */

  }, {
    key: "logout",
    value: function logout() {
      var uri = serverContextPath + "/api/auth/logout";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param redir 
     */

  }, {
    key: "ntlm",
    value: function ntlm(redir) {
      var uri = serverContextPath + "/api/auth/ntlm";
      var headers = undefined;
      var params = { redir: redir };

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }
  }]);
  return MarbesAuthApi;
}();

exports.default = MarbesAuthApi;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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